module.exports = __webpack_public_path__ + "static/media/Yveltal_gaussian2.41896afc.png";